<!--
 * @version: V1.0.0
 * @Date: 2023-10-27 16:50:49
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-15 14:43:54
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\traceability\components\DITable.vue
 * @Descripttion:
-->

<template>
  <div>
    <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border
      style="width:100%;margin-top: 10px">
      <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
        <template slot-scope="{ $index }">
          {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
        </template>
      </el-table-column>
      <el-table-column prop="orderCode" width="120px" show-overflow-tooltip label="订单编号" >
        <template slot-scope="{ row }">
          <el-button v-if="['SCRK', 'SMRK', 'YHCK'].includes(row.operationType)" @click="handleClick(row)">{{row.orderCode}}</el-button>
          <span v-else>{{row.orderCode}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px" prop="completeUdi" show-overflow-tooltip label="UDI码" />
      <el-table-column width="100px" prop="packLevel" show-overflow-tooltip label="包装级别" />
      <el-table-column min-width="100px" prop="productName" show-overflow-tooltip label="物料名称" />
      <el-table-column width="100px" prop="productCode" show-overflow-tooltip label="物料编码" />
      <el-table-column width="100px" prop="lot" show-overflow-tooltip label="批号" />
      <el-table-column width="100px" show-overflow-tooltip label="出入库状态">
        <template slot-scope="scope">
          <dict-tag :options="dictObj.delivery_status" :value="scope.row.deliveryState" />
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="number" width="120px" label="出入库数量"></el-table-column>
      <el-table-column width="100px" prop="operationType" show-overflow-tooltip label="操作项">
        <template slot-scope="scope">
          <dict-tag :options="dictObj.operation_type" :value="scope.row.operationType" />
          <el-tooltip
            v-if="scope.row.operationType==='RKBF'"
            effect="light"
            :content="scope.row.cancelReason"
            placement="top-start"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column width="100px" prop="operationUser" show-overflow-tooltip label="操作人" />
      <el-table-column width="160px" show-overflow-tooltip label="操作时间">
        <template slot-scope="scope">
          {{ scope.row.operationTime ? parseTime(scope.row.operationTime) : null }}
        </template>
      </el-table-column>
    </el-table>
    <orderInfo
      v-if="orderInfoVisible"
      :visible="orderInfoVisible"
      :dict-obj="dictObj"
      :order-id="orderId"
      :operation-type="operationType"
      @close="orderInfoVisible=false" ></orderInfo>
  </div>
</template>
<script>
import  orderInfo from './orderInfo.vue'
export default {
  name: 'DITable',
  components: {
    orderInfo
  },
  props: {
    pageListData: {
      type: Array,
      default() {
        return []
      }
    },
    heightStyleObj: {
      type: [String, Number],
      default() {
        return 0
      }
    },
    searchParam: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          delivery_status: [],
          operation_type: []
        }
      }
    }
  },
  data() {
    return {
      orderInfoVisible:false,
      orderId:'',
      operationType:'',
    }
  },
  methods: {
    handleClick(row) {
      this.orderId=row.orderId;
      this.operationType=row.operationType;
      this.orderInfoVisible = true;
    }
  }
}
</script>
